<template>
    <site-img
        v-if="list && list.length > 0"
        class="md-featured-area layout9 mg-bg"
        type="bgImg"
        :src="bgType == 'img' ? suitableImg : ''"
        :style="{
            ...spaceStyle,
            ...colorStyle,
            'background-color': bgColor
        }"
    >
        <div class="featured-area-container">
            <site-title
                class="featured-area-title f-col"
                :title="title"
                :mbSize="20"
                v-animated="textAnimation"
            />

            <div
                v-if="!isMobileSize"
                class="featured-area-div"
            >
                <div class="item-group" :class="'len' + itemGroup.length" v-for="(itemGroup, index) in pcList" :key="index">
                    <div
                        class="featured-area-item-wrap"
                        :class="{'item-two': itemArr.length > 1}"
                        v-for="(itemArr, itemArrIndex) in itemGroup"
                        :key="itemArrIndex"
                    >
                        <a
                            class="featured-area-item"
                            v-for="(item, itemIndex) in itemArr"
                            :key="itemIndex"
                            :href="item?.url"
                            rel="noopener noreferrer"
                        >
                            <img-box
                                v-if="item?.backPic"
                                class="featured-area-item-preview"
                                :src="item?.backPic"
                                dir="height"
                            />
                            <div v-else class="default-wrap">
                                <site-img
                                    :src="defaultImgSrc"
                                    dir="width"
                                />
                            </div>
                            <div
                                class="featured-area-item-img-mask"
                                v-if="maskOption.showMask"
                                :style="{
                                    backgroundColor: maskOption.maskColor
                                }"
                            ></div>
                            <div class="featured-area-item-bottom">
                                <site-title
                                    class="featured-area-item-sub-title"
                                    :size="24"
                                    :mbSize="20"
                                    :title="$ft.first(item?.name)"
                                    align="center"
                                />
                                <div
                                    class="featured-area-item-tag-wrap"
                                    v-if="item?.tagList?.length > 0"
                                >
                                    <span v-for="tag in item?.tagList" :key="tag">
                                        {{ tag }}
                                    </span>
                                </div>
                            </div>
                        </a>    
                    </div>
                </div>
            </div>

            <swiper
                v-else
                class="featured-area-div"
                :class="'len' + list.length"
                v-bind="swiperOptions"
            >
                <slide v-for="(item, index) in list" :key="item.url + index">
                    <a
                        class="featured-area-item"
                        :href="item.url"
                        rel="noopener noreferrer"
                    >
                        <img-box
                            v-if="item?.backPic"
                            class="featured-area-item-preview"
                            :src="item?.backPic"
                            dir="height"
                        />
                        <div v-else class="default-wrap">
                            <site-img
                                :src="defaultImgSrc"
                                dir="width"
                            />
                        </div>
                        <div
                            class="featured-area-item-img-mask"
                            :style="{
                                backgroundColor: maskOption.maskColor
                            }"
                        ></div>
                        <div class="featured-area-item-bottom">
                            <site-title
                                class="featured-area-item-sub-title"
                                :size="24"
                                :mbSize="18"
                                :title="$ft.first(item.name)"
                                align="center"
                            />
                            <div
                                class="featured-area-item-tag-wrap"
                                v-if="item?.tagList?.length > 0"
                            >
                                <span v-for="tag in item.tagList" :key="tag">
                                    {{ tag }}
                                </span>
                            </div>
                        </div>
                    </a>
                </slide>
            </swiper>
        </div>
    </site-img>
</template>

<script>
import common from '../index.js';
import { Swiper, SwiperSlide, fixSwiperOptions } from '@/common/swiper';
export default {
    mixins: [common],
    components: {
        Swiper,
        Slide: SwiperSlide
    },
    computed: {
        swiperOptions() {
            if (!this.isMobileSize) {
                return;
            }
            const obj = {
                spaceBetween: 2,
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                loop: false,
                centeredSlides: true,
                centeredSlidesBounds: true
            };
            return fixSwiperOptions(obj);
        },
        pcList() {
            let result = [], list = this.list;
            for (let i = 0; i < list.length; i += 7) {
                const subArray = list.slice(i, i + 7);
                
                // 手动拆分每个子数组
                const part1 = subArray.slice(0, 1);
                const part2 = subArray.slice(1, 2);
                const part3 = subArray.slice(2, 4); // 3和4放到一组
                const part4 = subArray.slice(4, 5);
                const part5 = subArray.slice(5, 6);
                const part6 = subArray.slice(6, 7);
                
                // 只在子数组的长度大于0时才推入结果数组
                const newSubArray = [];
                if (part1.length > 0) {
                    newSubArray.push(part1)
                }
                if (part2.length > 0) {
                    newSubArray.push(part2)
                }
                if (part3.length > 0) {
                    newSubArray.push(part3)
                }
                if (part4.length > 0) {
                    newSubArray.push(part4)
                }
                if (part5.length > 0) {
                    newSubArray.push(part5)
                }
                if (part6.length > 0) {
                    newSubArray.push(part6)
                }

                // 如果新数组不为空，则添加到结果数组中
                if (newSubArray.length > 0) {
                    result.push(newSubArray);
                }
            }
            return result;
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-featured-area.layout9 {
    @include media-800 {
       width: 100vw;
       overflow-x: hidden;
    }
    .featured-area-title {
        margin-bottom: 40px;
        @include media-800 {
            margin-bottom: 20px;
        }
    }

    .featured-area-div {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        gap: 2px;
        
        .featured-area-item {
            display: block;
            width: 100%;
            height: 100%;
            position: relative;
            overflow: hidden;
            filter: grayscale(100%);

            .featured-area-item-preview {
                width: 100%;
                height: 100%;
                overflow: hidden;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.3s;
                }
            }
            .default-wrap {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(218, 218, 218, 0.2);
                img {
                    width: 64px;
                    height: 56px;
                    object-fit: contain;
                    opacity: 0.3;
                }
                @include media-800 {
                    img {
                        width: 50px;
                        height: 44px;
                    }
                }
            }
            .featured-area-item-img-mask {
                position: absolute;
                z-index: 10;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                bottom: 0;
                right: 0;
            }
            .featured-area-item-bottom {
                width: 100%;
                padding: 30px 20px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: 0;
                z-index: 20;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                @include media-800 {
                    padding: 20px;
                }
                .featured-area-item-sub-title {
                    width: 100%;
                    color: #fff;
                    font-weight: 400 !important;
                    line-height: 36px;
                    transition: all 0.3s ease;
                    @include ellipsis;
                    @include media-800 {
                        line-height: 30px;
                    }
                }
                .featured-area-item-tag-wrap {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    row-gap: 10px;
                    padding-top: 30px;
                    opacity: 0;
                    transition: all 0.3s ease;
                    transform: translateY(190px);
                    position: absolute;
                    > span {
                        display: block;
                        font-size: 14px;
                        line-height: 17px;
                        font-weight: 400;
                        color: #fff;
                    }
                }
            }
            &:hover {
                filter: none;
                .featured-area-item-preview {
                    .img-content {
                        img {
                            transform: scale(1.1);
                        }
                    }
                }
                .featured-area-item-bottom {
                    .featured-area-item-sub-title {
                        padding-bottom: 30px;
                        border-bottom: 1px solid rgba(218, 218, 218, 0.5);
                        font-weight: 700 !important;
                    }
                    .featured-area-item-tag-wrap {
                        opacity: 1;
                        position: static;
                        transform: translateY(0);
                    }
                }
            }
        }

        .item-group {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 2px;

            &.len1 {
                .featured-area-item-wrap {
                    width: 100%;
                    height: 500px;
                }
            }
            &.len2 {
                .featured-area-item-wrap {
                    height: 500px;
                    &:nth-child(1) {
                        width: 25%;
                    }
                    &:nth-child(2) {
                        width: calc(100% - 25% - 2px);
                    }
                }
            }
            &.len3,
            &.len4,
            &.len5,
            &.len6 {
                .featured-area-item-wrap {
                    height: 500px;
                    &:nth-child(1),
                    &:nth-child(3) {
                        width: 21%;
                    }
                    &:nth-child(2) {
                        width: calc(100% - (21% + 2px) * 2);
                    } 

                    &.item-two {
                        display: flex;
                        flex-direction: column;
                        gap: 2px;
                        .featured-area-item {
                            height: 249px;
                        }
                    }
                }
            }
            &.len4 {
                .featured-area-item-wrap {
                    &:nth-child(4) {
                        width: 100%;
                        height: 350px;
                    }
                }
            }
            &.len5 {
                .featured-area-item-wrap {
                    &:nth-child(4),
                    &:nth-child(5) {
                        width: calc((100% - 2px) / 2);
                        height: 350px;
                    }
                }
            }
            &.len6 {
                .featured-area-item-wrap {
                    &:nth-child(4),
                    &:nth-child(5) {
                        width: 21%;
                        height: 350px;
                    }
                    &:nth-child(6) {
                        width: calc(100% - (21% + 2px) * 2);
                        height: 350px;
                    }
                }
            }
        }

        @include media-800 {
            display: block;
            .swiper-slide {
                width: 335px;
                height: 265px;
                &:first-child {
                    margin-left: 15px;
                }

                .featured-area-item {
                    width: 100%;
                    height: 100%;
                    filter: none;

                    .featured-area-item-bottom {
                        .featured-area-item-tag-wrap {
                            width: 100%;
                            margin-top: 15px;
                            padding-top: 15px;
                            border-top: 1px solid rgba(218, 218, 218, 0.5);
                            opacity: 1;
                            position: static;
                            transform: translateY(0);
                        }
                    }
                    &:hover {
                        .featured-area-item-sub-title {
                            padding-bottom: 0;
                            border-bottom: none;
                        }
                    }
                }
            }

            &.len1 {
                .swiper-wrapper {
                    justify-content: center;
                }
                .swiper-slide {
                    &:first-child {
                        margin-left: 0;
                        margin-right: 0 !important;
                    }
                }
            }
        }
    }
}
</style>
